// src/components/AvatarSection.jsx
import React from 'react';

export default function AvatarSection({ src, alt }) {
  return (
    <div className="canario-foto">
      <img
        src={src}
        alt={alt || 'avatar'}
        className="rounded-circle mx-auto d-block"
      />
    </div>
  );
}
